import { app } from './app'
import { enableEmulators } from './config'
const db = app.firestore()

if (enableEmulators) {
  db.settings({
    host: 'localhost:5050',
    ssl: false,
  })
}
export { db }
